import { setupPrototypes } from './prototypes.js'; setupPrototypes();
import { setupHelpers } from './helpers.js'; setupHelpers();
import { setupState } from './state.js'; setupState();

import Vue from 'vue'
import UserPortal from './UserPortal.vue'
import store from "./store/store";
import FloatingVue from 'floating-vue'
import 'floating-vue/dist/style.css'


/* local */ // window.portal.api_server = 'https://mothership.local';
/* staging */ // window.portal.api_server = 'https://othership.shambhalamusicfestival.com';
/* live */ window.portal.api_server = process.env.VUE_APP_API_BASE_URL;

/* local */ // window.portal.welcome_portal = 'https://welcome.local';
/* staging */ //window.portal.welcome_portal = 'https://wellcred.shambhalamusicfestival.com';
/* live */ window.portal.welcome_portal = process.env.VUE_APP_WELCOME_URL;

window.portal.debugging = false;
window.portal.login_secret = process.env.VUE_APP_LOGIN_SECRET;
window.portal.forgot_secret = process.env.VUE_APP_FORGOT_SECRET;
window.portal.show_reset_secret = process.env.VUE_APP_SHOW_RESET_SECRET;
window.portal.reset_secret = process.env.VUE_APP_RESET_SECRET;
window.portal.ticket_url = process.env.VUE_APP_TICKETING_URL;

window.portal.show_notification = process.env.VUE_APP_SHOW_SITE_NOTIFICATION ? process.env.VUE_APP_SHOW_SITE_NOTIFICATION.toLowerCase() === "true" : false;
window.portal.notification_msg = process.env.VUE_APP_SHOW_SITE_NOTIFICATION_MESSAGE;

const vueSmoothScroll = require('vue-smoothscroll');
Vue.use(vueSmoothScroll);
Vue.use(FloatingVue);

window.portal.app = new Vue({
	render: h => h(UserPortal),
	store: store
}).$mount('#user_portal');
